<div class="ui-g-12">
  <div class="ui-g">
    <div class="ui-g-12 ui-md-12">

    </div>
    <div class="ui-g-12 ui-md-12">
      <div *ngFor="let indicator of indicators" class="ui-g-3 ui-md-3 ui-sm-6 ui-xs-12">
        <app-infobox [pointData]="indicator.pointData" [options]="indicator.options"></app-infobox>
      </div>
    </div>
  </div>

  <div class="ui-g-12 ui-md-6 ui-sm-12" *ngIf="data != null">
    <h2>{{ translations.overview_fatturato_pvd }}</h2>
    <div class="chart-container">
      <chart [options]="overviweChart.options" (load)="setChartInstance(overviweChart, $event.context)"></chart>
    </div>
  </div>

  <div class="ui-g-12 ui-md-6 ui-sm-12" *ngIf="data != null">
    <h2>{{ translations.mappa }}</h2>
    <agm-map [latitude]="lat" [longitude]="lng">
      <agm-marker *ngFor="let store of mapChart" [latitude]="store.lat" [longitude]="store.lng">
        <agm-info-window>
          <strong>{{store.name}}</strong>
        </agm-info-window>
      </agm-marker>
    </agm-map>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/store/panoramica/shop-overview-main-kpi/shop-overview-main-kpi.component.html